import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "registration-culture-chart__title" };
const _hoisted_2 = ["innerHTML"];
import { computed, reactive, watch } from 'vue';
import moment from 'moment';
import { formatPercent, formatDecimal, formatCurrency } from '@/utilities/formatters';
import { fetchMetrics } from '@/features/RegistrationCulture/data/fetchMetrics';
import { useStore } from 'vuex';
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
import InfoCard from '@/components/_atoms/InfoCard.vue';
import i18n from '@/i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RegistrationCultureChart',
    props: {
        title: {},
        description: {},
        typeMetrics: {}
    },
    setup(__props) {
        const props = __props;
        const state = reactive({
            data: {
                metricsIdentifiedOrders: {
                    identified_orders_rate: [],
                    not_identified_orders_rate: [],
                    total_orders: [],
                },
                metricsOrdersIdentifiedField: {
                    identified_address_rate: [],
                    identified_birthdate_rate: [],
                    identified_email_rate: [],
                    identified_mobile_rate: [],
                    total_identified: [],
                },
            },
            dates: [],
            loading: false,
            hasError: false,
            hasData: true,
        });
        const store = useStore();
        const selectedDates = computed(() => store.getters?.dates || []);
        const maxLeftYAxis = computed(() => {
            return Math.max(...seriesIdentifiedOrders.value[0].data, ...seriesOrdersIdentifiedField.value[0].data);
        });
        const seriesIdentifiedOrders = computed(() => [
            {
                name: i18n.global.t('registration-culture.charts.legend.total_orders'),
                type: 'column',
                color: '#F2F2F2',
                data: state.data.metricsIdentifiedOrders.total_orders,
                marker: { symbol: 'circle' },
            },
            {
                name: i18n.global.t('registration-culture.charts.legend.identified_rate'),
                type: 'line',
                color: '#1EA657',
                data: state.data.metricsIdentifiedOrders.identified_orders_rate,
                marker: { symbol: 'line' },
                yAxis: 1,
            },
            {
                name: i18n.global.t('registration-culture.charts.legend.unidentified_fictitious_rate'),
                type: 'line',
                color: '#C23729',
                data: state.data.metricsIdentifiedOrders.not_identified_orders_rate,
                marker: { symbol: 'line' },
                yAxis: 1,
            },
        ]);
        const seriesOrdersIdentifiedField = computed(() => [
            {
                name: i18n.global.t('registration-culture.charts.legend.total_identified'),
                type: 'column',
                color: '#F2F2F2',
                data: state.data.metricsOrdersIdentifiedField.total_identified,
                marker: { symbol: 'circle' },
            },
            {
                name: i18n.global.t('registration-culture.charts.legend.identified_email_rate'),
                type: 'line',
                color: '#0072f0',
                data: state.data.metricsOrdersIdentifiedField.identified_email_rate,
                marker: { symbol: 'line' },
                yAxis: 1,
            },
            {
                name: i18n.global.t('registration-culture.charts.legend.identified_mobile_rate'),
                type: 'line',
                color: '#f66d00',
                data: state.data.metricsOrdersIdentifiedField.identified_mobile_rate,
                marker: { symbol: 'line' },
                yAxis: 1,
            },
            {
                name: i18n.global.t('registration-culture.charts.legend.identified_birthdate_rate'),
                type: 'line',
                color: '#f10096',
                data: state.data.metricsOrdersIdentifiedField.identified_birthdate_rate,
                marker: { symbol: 'line' },
                yAxis: 1,
            },
            {
                name: i18n.global.t('registration-culture.charts.legend.identified_address_rate'),
                type: 'line',
                color: '#00b6cb',
                data: state.data.metricsOrdersIdentifiedField.identified_address_rate,
                marker: { symbol: 'line' },
                yAxis: 1,
            },
        ]);
        const formatLargeNumber = (num) => {
            const formattedToCurrency = formatCurrency(num, { shortNumber: true });
            const removeCurrencySymbol = formattedToCurrency.replace(/^\D+/, '');
            const cleanedString = removeCurrencySymbol.replace(',', '.');
            return cleanedString;
        };
        const getChartOptions = computed(() => ({
            chart: {
                zoomType: 'xy',
                height: 400,
                events: {
                    load: function () {
                        document.querySelectorAll('.highcharts-legend-item path').forEach(function (element) {
                            element.setAttribute('stroke-width', '5');
                        });
                    },
                },
                style: {
                    fontFamily: 'Montserrat',
                    margin: '0 auto',
                },
            },
            title: {
                text: null,
            },
            legend: {
                itemMarginTop: -30,
                itemMarginBottom: 35,
                itemDistance: 20,
                enabled: true,
                align: 'left',
                verticalAlign: 'top',
                itemStyle: {
                    color: '#555',
                    fontWeight: 600,
                },
            },
            tooltip: {
                shared: true,
                useHTML: true,
                borderWidth: 0,
                backgroundColor: '#fff',
                padding: 14,
                formatter: function formater() {
                    const totalOrders = i18n.global.t('registration-culture.charts.legend.total_orders');
                    const totalIdentified = i18n.global.t('registration-culture.charts.legend.total_identified');
                    const htmlTooltip = this.points.map(info => {
                        if (info.series.name === totalOrders || info.series.name === totalIdentified) {
                            return `<div><b>${info.key}</b><div style="display: flex; align-items: center; margin-bottom: 5px; margin-top: 8px"><div style="color:${info.color}; margin-right: 5px; height: 10px; width: 10px ;background-color:${info.color}; border-radius: 50%"></div>${info.series.name}: <b style="margin-left: 3px">${formatDecimal(info.y)}</b></div> </div>`;
                        }
                        else {
                            return `<div style="display: flex; align-items: center; margin-bottom: 5px"><div style="color:${info.color}; margin-right: 5px; height: 5px; width: 10px ;background-color:${info.color} "></div><span>${info.series.name}</span>: <b style="margin-left: 3px">${formatPercent(info.y / 100)}</b></div> `;
                        }
                    });
                    return htmlTooltip;
                },
            },
            plotOptions: {
                series: { marker: { enabled: false } },
                column: {
                    states: {
                        hover: {
                            color: '#F2F2F2',
                        },
                    },
                },
            },
            credits: {
                enabled: false,
            },
            xAxis: {
                labels: {
                    rotation: -45,
                },
                categories: Object.values(state.dates).map((date) => {
                    if (date.split('-').length === 3) {
                        return moment(date).format('DD/MM/YYYY');
                    }
                    else {
                        return moment(date).format('MM/YYYY');
                    }
                }),
                tickWidth: 0,
            },
            yAxis: [
                {
                    title: {
                        text: null,
                    },
                    max: maxLeftYAxis.value,
                    tickPositions: [
                        0,
                        maxLeftYAxis.value * 0.2,
                        maxLeftYAxis.value * 0.4,
                        maxLeftYAxis.value * 0.6,
                        maxLeftYAxis.value * 0.8,
                        maxLeftYAxis.value,
                    ],
                    lineWidth: 0,
                    labels: {
                        style: {
                            width: '60px',
                            whiteSpace: 'normal',
                        },
                        formatter: function formatter(data) {
                            return formatLargeNumber(data.value);
                        },
                    },
                },
                {
                    tickPositions: [0, 20, 40, 60, 80, 100],
                    max: 100,
                    lineWidth: 0,
                    opposite: true,
                    title: {
                        text: null,
                    },
                    labels: {
                        style: {
                            width: '60px',
                            whiteSpace: 'normal',
                        },
                        formatter: function formatter(data) {
                            return formatPercent(data.value / 100);
                        },
                    },
                },
            ],
            series: props.typeMetrics === 'identified_orders' ? seriesIdentifiedOrders.value : seriesOrdersIdentifiedField.value,
        }));
        const fetchMetricsIdentifiedOrders = async () => {
            state.loading = true;
            await fetchMetrics(selectedDates.value, 'identified_orders')
                .then(data => {
                if (data === null) {
                    state.hasData = false;
                    return;
                }
                state.hasData = true;
                state.dates = data.labels;
                state.data.metricsIdentifiedOrders = data.metrics;
            })
                .catch(() => {
                state.hasData = false;
                state.hasError = true;
            })
                .finally(() => {
                state.loading = false;
            });
        };
        const fetchMetricsOrdersIdentifiedField = async () => {
            state.loading = true;
            await fetchMetrics(selectedDates.value, 'orders_identified_field')
                .then(data => {
                if (data === null) {
                    state.hasData = false;
                    return;
                }
                state.hasData = true;
                state.dates = data.labels;
                state.data.metricsOrdersIdentifiedField = data.metrics;
            })
                .catch(() => {
                state.hasData = false;
                state.hasError = true;
            })
                .finally(() => {
                state.loading = false;
            });
        };
        const fetchAllMetrics = () => {
            if (props.typeMetrics === 'identified_orders') {
                fetchMetricsIdentifiedOrders();
            }
            else {
                fetchMetricsOrdersIdentifiedField();
            }
        };
        watch(selectedDates.value, () => {
            fetchAllMetrics();
        });
        fetchAllMetrics();
        return (_ctx, _cache) => {
            const _component_highcharts = _resolveComponent("highcharts");
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (_openBlock(), _createBlock(_component_base_card_v2, { class: "registration-culture-chart" }, {
                default: _withCtx(() => [
                    (!state.loading && !state.hasError && state.hasData)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("strong", _hoisted_1, _toDisplayString(props.title), 1),
                            (props.description)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    innerHTML: props.description,
                                    class: "registration-culture-chart__description"
                                }, null, 8, _hoisted_2))
                                : _createCommentVNode("", true),
                            _createVNode(_component_highcharts, {
                                options: getChartOptions.value,
                                class: "registration-culture-chart__highcharts"
                            }, null, 8, ["options"])
                        ], 64))
                        : _createCommentVNode("", true),
                    (state.loading)
                        ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                        : _createCommentVNode("", true),
                    (!state.hasData && !state.loading)
                        ? (_openBlock(), _createBlock(InfoCard, {
                            key: 2,
                            ref: "message-error",
                            error: state.hasError
                        }, null, 8, ["error"]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
